'use strict';


var shipping = require('base/checkout/shipping');
var formHelpers = require('base/checkout/formErrors');
var scrollAnimate = require('base/components/scrollAnimate');


/**
 * Handle response from the server for valid or invalid form fields.
 * @param {Object} defer - the deferred object which will resolve on success or reject.
 * @param {Object} data - the response data with the invalid form fields or
 *  valid model data.
 */
function shippingFormResponse(defer, data) {
    var isMultiShip = $('#checkout-main').hasClass('multi-ship');
    var formSelector = isMultiShip
        ? '.multi-shipping .active form'
        : '.single-shipping form';


    // customer Email validation
    var customerEmailError = false;
    if($('#guest-email').length) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if($('#guest-email').val().trim() && emailRegex.test($('#guest-email').val().trim())) {
            $('#guest-email').closest('form').find('.invalid-feedback').hide();
            $('#guest-email').closest('form').find('.existing-user-msg').hide();
        } else {
            customerEmailError = true;
        }
        if (data.existingEmailError) {
            customerEmailError = true;
        }
    }


    // highlight fields with errors
    if (data.error || customerEmailError) {
        if (data.fieldErrors && data.fieldErrors.length) {
            data.fieldErrors.forEach(function (error) {
                if (Object.keys(error).length) {
                    formHelpers.loadFormErrors(formSelector, error);
                }
            });
            defer.reject(data);
        }

        // CustomerEmailError 
        if (customerEmailError) {
            customerEmailError = true;
            let customerForm = $('#guest-email').closest('form');
            customerForm.find('.invalid-feedback').hide();
            customerForm.find('.existing-user-msg').hide();
            if (data.existingEmailError) {
                customerForm.find('.existing-user-msg').text(data.existingEmailError).show();
            } else {
                customerForm.find('.invalid-feedback').show();
            }
            defer.reject(data);
        }

        if (data.serverErrors && data.serverErrors.length) {
            $.each(data.serverErrors, function (index, element) {
                shipping.methods.createErrorNotification(element);
            });

            defer.reject(data);
        }

        if (data.cartError) {
            window.location.href = data.redirectUrl;
            defer.reject();
        }
    } else {
        // Populate the Address Summary

        $('body').trigger('checkout:updateCheckoutView', {
            order: data.order,
            customer: data.customer
        });
        scrollAnimate($('.payment-form'));
        defer.resolve(data);
    }
}

/**
 * Builds the read-only address-summary markup that addressSummary.isml
 * renders once an address is complete (mirrors its firstName/lastName/
 * addressType/address1-line/shipping-phone structure). Values are set via
 * .text() (not string-concatenated HTML) so user-entered address data can't
 * be interpreted as markup.
 * @param {Object} address - shipping.shippingAddress model
 * @returns {jQuery} the built .address-summary element
 */
function buildAddressSummaryMarkup(address) {
    var $wrap = $('<div class="address-summary"></div>');
    var $nameRow = $('<div class="d-flex address-summary-content"></div>').appendTo($wrap);
    $('<strong class="firstName"></strong>').text(address.firstName || '').appendTo($nameRow);
    $('<strong class="lastName"></strong>').text(address.lastName || '').appendTo($nameRow);
    $('<span class="address-type-tag addressType"></span>').text(address.addressType || '').appendTo($nameRow);

    var $lineRow = $('<div class="address1-line"></div>').appendTo($wrap);
    $('<span class="address1"></span>').text(address.address1 || '').appendTo($lineRow);
     if (address.address2) {
        $('<span class="address2"></span>').text(address.address2 || '').appendTo($lineRow);
    }  
    $('<span class="city"></span>').text(address.city || '').appendTo($lineRow);
    $('<span class="stateFullName"></span>').text(address.stateFullName || '').appendTo($lineRow);
    $('<span class="postalCode"></span>').text(address.postalCode || '').appendTo($lineRow);
    if (address.phone) {
        $('<span class="shipping-phone"></span>').text(address.phone).appendTo($lineRow);
    }

    return $wrap;
}

/**
 * The .customer-summary card (guest "Customer Information" read-only block)
 * only server-renders once currentStage is already 'payment', so on a fresh
 * guest checkout it doesn't exist yet when the address is saved via AJAX -
 * a hidden, correctly-localized template (#customer-summary-template) is
 * rendered instead so this can reveal it in place, rather than needing to
 * hardcode English label text here.
 * @param {Object} customer - the customer model
 * @param {Object} order - the order model
 */
function revealCustomerSummary(customer, order) {
    // Keyed off the .customer-summary class (present whether this is still
    // the hidden template or an already-revealed live card, and mutually
    // exclusive per checkout.isml's <isif>), not the #customer-summary-template
    // id - that id is stripped below on first reveal, so keying off it made
    // this a one-shot function and every re-save after an Edit -> re-save
    // cycle silently skipped hiding .guest-customer-section again.
    var $template = $('.customer-summary');
    if (!$template .length) {
        return;
    }

    var email = (customer && customer.profile && customer.profile.email)
        ? customer.profile.email
        : (order && order.orderEmail);
    if (!email) {
        return;
    }

    $template.find('.customer-summary-email').text(email);
    $template.removeAttr('id').removeClass('d-none');
    // .guest-customer-section only gets d-none from the server when
    // currentStage is already 'payment' at render time; nothing else hides
    // it, so it has to be hidden here too or the email form and the summary
    // card just visible above would show at the same time.
    $('.guest-customer-section').addClass('d-none');
}

/**
 * The en_IN Estimated Delivery card only server-renders once postalCode
 * already exists on the shipment (a dimmed ghost preview shows before that -
 * see checkout.isml), so a first-time AJAX save has nothing to swap into.
 * Both the success and warning (CMS content asset) states are prepared
 * server-side in the hidden #edd-summary-template, since the warning message
 * is real CMS content that can't be safely rebuilt here; this only picks
 * which one to show and fills in the day count.
 * @param {Object} order - the order model
 */
function revealEddSummary(order) {
    var $template = $('#edd-summary-template');
    if (!$template.length) {
        return;
    }

    var deliveryDateCheck = order && order.deliveryDateCheck;
    if (deliveryDateCheck && deliveryDateCheck.success === true) {
        $template.find('.edd-days').text((deliveryDateCheck.data && deliveryDateCheck.data.days) || '');
        $template.find('.edd-success').removeClass('d-none');
        $template.find('.edd-warning').addClass('d-none');
    } else {
        $template.find('.edd-success').addClass('d-none');
        $template.find('.edd-warning').removeClass('d-none');
    }

    $template.removeAttr('id').removeClass('d-none');
    $('#edd-summary-ghost').remove();
}

/**
 * The guest shipping .edit-button only server-renders once currentStage is
 * already 'payment', so on a first-time AJAX address save it isn't in the
 * DOM yet (see revealCustomerSummary above for the same problem on the
 * customer-summary card). A hidden, correctly-localized
 * #shipping-edit-button-template is rendered instead so this reveals it in
 * place. The registered-customer "Change Address"/"Add New Address"
 * buttons no longer need this - they now always render visible since the
 * shipping address is already complete by the time that markup is reached.
 */
function revealShippingEditControls() {
    var isRegistered = $('.data-checkout-stage').data('customer-type') === 'registered';

    if (!isRegistered) {
        $('#shipping-edit-button-template').removeAttr('id').removeClass('d-none');
    }
}

/**
 * On first save, addressSummary.isml's "migrated user" placeholder
 * ("Please ... to proceed.") was server-rendered because no address existed
 * yet - it's a different isml branch than the real .address-summary, so the
 * base populateAddressSummary()'s per-field .text() updates have nothing to
 * update (the .address-summary element was never rendered) and the
 * placeholder is stuck until a full reload. Swap it out here once the saved
 * address is actually complete.
 */
$('body').on('shipping:updateShippingInformation', function (e, data) {
    var address = data.shipping && data.shipping.shippingAddress;
    var isAddressComplete = !!(address && address.firstName && address.lastName
        && address.address1 && address.phone && address.city && address.stateCode
        && address.postalCode);

    if (!isAddressComplete) {
        return;
    }

    revealCustomerSummary(data.customer, data.order);
    revealEddSummary(data.order);
    revealShippingEditControls();

    $('[data-shipment-summary=' + data.shipping.UUID + ']').each(function (i, el) {
        var $container = $(el);
        var $wrapper = $container.find('.address-summary-wrapper');
        if ($wrapper.length && $wrapper.find('.address-summary').length === 0) {
            $wrapper.empty().append(buildAddressSummaryMarkup(address));
        }
        // This marker only exists because the address was incomplete at
        // render time - remove it now so dependents (e.g. the payment tabs'
        // disabled state) that key off its presence pick up the change.
        $container.find('.migratedUserAddressNotUpdated').remove();
    });

    $('body').trigger('shipping:addressBecameComplete', { shipping: data.shipping });
});

shipping.methods.shippingFormResponse = shippingFormResponse;
module.exports = shipping;
